export default "__VITE_ASSET__c683395c__"